import { api } from "@/lib/api";
import { setSyncingStatus } from "@/store/slices/networkSlice";
import { store } from "@/store/store";
import { getOfflineRequests, removeOfflineRequest } from "@/utils/offlineQueue";
import ToastService from "@/utils/toast";

async function syncOfflineRequests() {
  const requests = await getOfflineRequests();
  if (requests.length === 0) return;

  const isOnline = store.getState().network.isOnline;
  if (!isOnline) return;

  store.dispatch(setSyncingStatus(true));

  for (const request of requests) {
    try {
      console.log("[SyncManager] Retrying request:", request.url);

      const response = await api.axiosInstance({
        method: request.method,
        url: request.url,
        data: request.data,
        headers: request.headers,
      });

      if ([200, 201, 204].includes(response.status)) {
        console.log("[SyncManager] Request successful:", request.url);
      }
    } catch (error) {
      console.error("[SyncManager] Failed to sync request:", request.url);
    } finally {
      await removeOfflineRequest(request.id);
    }
  }

  store.dispatch(setSyncingStatus(false));
  ToastService.success("Offline data successfully synced!");
  window.location.reload();
}

export { syncOfflineRequests };
